module.exports = __webpack_public_path__ + "img/guide-recipe-scroll.6beda704.gif";